import React from 'react'

const LinkIcon = ({ className = '', ...props }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none"
      className={`transition-colors duration-200 ${className}`}
      {...props}
    >
      <path 
        d="M10.0453 14.0001C8.53933 12.4881 8.67533 9.90008 10.3483 8.22108L15.1963 3.35508C16.8693 1.67508 19.4463 1.53908 20.9533 3.05008C22.4603 4.56108 22.3233 7.15008 20.6503 8.83008L18.2263 11.2631" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round"
      />
      <path 
        d="M13.9537 10C15.4597 11.512 15.3237 14.1 13.6507 15.779L11.2267 18.212L8.80273 20.645C7.12973 22.325 4.55273 22.461 3.04573 20.95C1.53873 19.439 1.67573 16.85 3.34873 15.17L5.77273 12.737" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round"
      />
    </svg>
  )
}

export default LinkIcon
